import React, { useState } from "react";
import { API } from "aws-amplify";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import analytics from "../analytics";
import logger from "../logger";
import ProductCard from "../templates/ecommerce/components/ProductCard";
import ProductDetails from "../templates/ecommerce/components/ProductDetails";

const useStyles = makeStyles(theme => ({
  searchField: {
    margin: theme.spacing(2, "auto"),
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  searchInput: {
    width: "80vw",
    maxWidth: "600px"
  },
  searchButton: {
    width: "10vw",
    maxWidth: "200px",
    marginLeft: theme.spacing(1)
  },
  products: {
    display: "flex",
    alignItems: "flex-start",
    flexWrap: "wrap"
  },
  product: {
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      margin: "2.5%"
    }
  }
}));

const Marketplace = () => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [searchtext, setSearchtext] = useState("");
  const [products, setProducts] = useState([]);
  const [notFound, setNotFound] = useState(false);
  const [selectedProduct, setSelectProduct] = useState(null);

  const search = async () => {
    if (searchtext) {
      setLoading(true);
      setProducts([]);
      setNotFound(false);

      try {
        const init = {
          body: {
            searchtext
          }
        };

        const results = await API.post("carritofacilapi", "/marketplace/search", init);

        if (results.data && results.data.length > 0) {
          setProducts(results.data);
        } else {
          setNotFound(true);
        }
      } catch (err) {
        logger("Marketplace.search.error", err);
      } finally {
        setLoading(false);
      }
    }
  };

  const selectProduct = product => {
    if (product) {
      analytics.products([product.id], analytics.metrics.products.vista);
    }

    setSelectProduct(product);
  };

  const searchKeyPressed = e => {
    if (e.key === "Enter") {
      search();
    }
  };

  return (
    <>
      {selectedProduct && (
        <ProductDetails
          items={[]}
          product={selectedProduct}
          onChange={e => console.log("product.details.change", e)}
          onClose={() => setSelectProduct(null)}
        />
      )}
      <div className={classes.searchField}>
        <TextField
          className={classes.searchInput}
          placeholder="Ingresa el producto que quieres buscar"
          variant="outlined"
          size="small"
          disabled={loading}
          value={searchtext}
          onChange={({ target }) => setSearchtext(target.value)}
          onKeyPress={searchKeyPressed}
        />
        <Button
          className={classes.searchButton}
          variant="contained"
          color="primary"
          disabled={loading}
          onClick={search}
        >
          Buscar
        </Button>
      </div>

      {loading && (
        <Typography variant="body2" color="textSecondary" align="center">
          Buscando...
        </Typography>
      )}

      {notFound && (
        <Typography variant="body2" color="textSecondary" align="center">
          No se encontraron productos
        </Typography>
      )}

      {products.length > 0 && (
        <div className={classes.products}>
          {products.map((product, index) => (
            <ProductCard
              key={`product-${index}`}
              className={classes.product}
              product={product}
              onSelected={selectProduct}
            />
          ))}
        </div>
      )}
    </>
  );
};

export default Marketplace;
